import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import HomePage from './Components/HomePage/HomePage';
import { globals } from './Components/Globals/Globals';
import StatFormDialog from "./Components/Modal/StatFormDialog";
import ArticleFormDialog from "./Components/Modal/ArticleFormDialog";
import BlogFormDialog from "./Components/Modal/BlogFormDialog"
import HiringFormDialog from './Components/Modal/HiringFormDialog';
import HiringContactDialog from './Components/Modal/HiringContactDialog'
import AwardFormDialog from "./Components/Modal/AwardFormDialog";
import ToolboxPartnerFormDialog from './Components/Modal/ToolboxPartnerFormDialog';
import VideoFormDialog from './Components/Modal/VideoFormDialog';
import ParamFormDialog from './Components/Modal/ParamFormDialog';
import Modal from './Components/Modal/Modal';

import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import AdminStatsView from './Views/AdminStatsView';
import AdminArticlesView from './Views/AdminArticlesView';
import AdminBlogsView from './Views/AdminBlogsView';
import AdminHiringView from './Views/AdminHiringsView';
import AdminAwardsView from './Views/AdminAwardsView';
import AdminToolboxView from "./Views/AdminToolboxView";
import AdminVideoView from "./Views/AdminVideoView";
import AdminParamsView from './Views/AdminParamsView';

import { useSelector } from 'react-redux';
import LoginView from './Views/LoginView';

import RssFeed from './Components/RssFeed/RssFeed';

// styles
import "./Assets/css/bootstrap.min.css";

const App = () => {

  const {dialogModal, statModal, articleModal, blogModal, hiringModal, awardModal, toolboxModal, videoModal, paramModal, hiringContactModal} = useSelector((store) => store.modal);

  return (
      <BrowserRouter>
          {dialogModal.isOpen && <Modal/>}
          {statModal.isOpen && <StatFormDialog/>}
          {hiringModal.isOpen && <HiringFormDialog/>}
          {hiringContactModal.isOpen && <HiringContactDialog/>}
          {articleModal.isOpen && <ArticleFormDialog/>}
          {blogModal.isOpen && <BlogFormDialog/>}
          {awardModal.isOpen && <AwardFormDialog/>}
          {toolboxModal.isOpen && <ToolboxPartnerFormDialog/>}
          {videoModal.isOpen && <VideoFormDialog/>}
          {paramModal.isOpen && <ParamFormDialog/>}
        
          <Routes>
            <Route path="/params-page" element={<ProtectedRoute><AdminStatsView/></ProtectedRoute>}/>
            <Route path="/stats-page" element={<ProtectedRoute><AdminStatsView/></ProtectedRoute>}/>
            <Route path="/articles-page" element={<ProtectedRoute><AdminArticlesView/></ProtectedRoute>}/>
            <Route path="/blogs-page" element={<ProtectedRoute><AdminBlogsView/></ProtectedRoute>}/>
            <Route path="/awards-page" element={<ProtectedRoute><AdminAwardsView/></ProtectedRoute>}/>
            <Route path="/toolbox-page" element={<ProtectedRoute><AdminToolboxView/></ProtectedRoute>}/>
            <Route path="/video-page" element={<ProtectedRoute><AdminVideoView/></ProtectedRoute>}/>
            <Route path="/hiring-page" element={<ProtectedRoute><AdminHiringView/></ProtectedRoute>}/>
            <Route path="/login-page" element={<LoginView />}/>
            <Route exact path = "/" element={<HomePage/>} />

            {globals.parameters.rss &&
            <Route exact path='/rss' element={<RssFeed/>}/>}

            <Route
              path="*"
              element={<Navigate to="/" replace />}
            />
          </Routes>
      </BrowserRouter>
    );
  
}

export default App;